import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4q06brhpm1: FaireBrandEntity = {
  token: "b_4q06brhpm1",
  type: "brand",
  name: "Harvest House Publishers Gift & Specialty Books",
  avatarUrl:
    "https://cdn.faire.com/fastly/23439e4ab6ef3cfcb8760dc76f0046da3804d0fec47dd0032ce9f2b9b6041186.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/46a3974f21a069da74a349b499cb13164ae866c95e9a0e4b230fb6b94adcdea7.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/23439e4ab6ef3cfcb8760dc76f0046da3804d0fec47dd0032ce9f2b9b6041186.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/46a3974f21a069da74a349b499cb13164ae866c95e9a0e4b230fb6b94adcdea7.jpeg",
  location: "Eugene, OR, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 352,
  isTopShop: true,
  isInsider: true,
  description:
    "Harvest House Publishers’ gift and specialty books combine high-quality design and packaging with encouraging content at an affordable price. With over 25 years of experience publishing strong-selling titles for the gift trade, Harvest House is a trusted source for innovative and inspirational books and ancillary products that celebrate the best of friends, family, faith, and food. \n\nBuy 6 of any title and get the 7th free! The free book(s) will be reflected on the packing list, no need to enter them on your order.\n\nView our Winter 2026 Gift & Specialty catalog/cataloque (for our friends in Canada)  for new and best selling titles at https://tinyurl.com/HHPWinter2026",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:47.196Z",
    importedBy: "entity-db-cli",
  },
};
